import {
  getStatisticPlaygroundData,
  type StatisticPlaygroundDataResContent as PlayGroundResDataType,
} from '../../api/playgroundApi';
import { logger } from '../../util/logger';
import { MapLevel, centerLagLnt, getCenterByAdcode } from './constant';

export const averageLnglat = (list: Array<{ latitude: number; longitude: number }>) => {
  const len = list.length;

  const total = list.reduce(
    (res, item) => {
      res.latitude += item.latitude;
      res.longitude += item.longitude;
      return { ...res };
    },
    { latitude: 0, longitude: 0 },
  );

  return {
    latitude: len > 0 ? total.latitude / len : 0,
    longitude: len > 0 ? total.longitude / len : 0,
  };
};

// 无筛选时按 acType 缓存；有筛选时按 lanType + acType + province + city 四维缓存
const cacheMap = new Map<string, PlayGroundResDataType[]>();

/**
 * 获取地图 marker 数据，支持可选的省市筛选参数。
 * cache key 统一为 `${lanType}_${acType}_${provinceAdCode}_${cityAdCode}`
 */
export const getMarkerDataList = async (
  params: { acType: MapLevel; lanType: string; provinceAdCode?: string; cityAdCode?: string },
  path?: string,
) => {
  const { acType: level, lanType, provinceAdCode = '', cityAdCode = '' } = params;
  const cacheKey = `${lanType}_${level}_${provinceAdCode}_${cityAdCode}`;

  if (cacheMap.has(cacheKey)) {
    return cacheMap.get(cacheKey) as PlayGroundResDataType[];
  }

  try {
    const res = await getStatisticPlaygroundData(params, path);
    if (res.code !== 0) {
      throw res;
    }
    let { data } = res;
    // 处理全国数据
    if (level === 'GLOBAL') {
      data = data.map((item) => {
        return {
          ...item,
          latitude: centerLagLnt[0],
          longitude: centerLagLnt[1],
        };
      });
    } else if (level === 'COUNTRY') {
      data = data.map((item) => {
        const center = getCenterByAdcode(item.adCode as any);
        return {
          ...item,
          latitude: center[1],
          longitude: center[0],
        };
      });
    }
    const finalPgStatsLists = data
      .map((dataItem) => {
        const { latitude, longitude, ...otherData } = dataItem;
        return {
          ...otherData,
          latitude: Number(latitude) || 0,
          longitude: Number(longitude) || 0,
        };
      })
      .filter((markerItemData: PlayGroundResDataType) => markerItemData.latitude && markerItemData.longitude)
      .sort((a, b) => b.latitude - a.latitude);
    cacheMap.set(cacheKey, finalPgStatsLists);
    return finalPgStatsLists;
  } catch (e) {
    logger.error(`${path}, ${JSON.stringify(params)} 请求错误`);
    return [];
  }
};

export const detectWebGLContext = () => {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  if (gl && gl instanceof WebGLRenderingContext) {
    return true;
  }
  return false;
};

export const filterPointByBounds = (opts: { data: Array<{ latitude: number; longitude: number }>; bounds: any }) => {
  const { data = [], bounds } = opts;

  return data.filter((_) => {
    const { sw, ne } = bounds;
    const { lat, lng } = sw;
    if (_.latitude < lat || _.longitude < lng) {
      return false;
    }
    if (_.latitude > ne.lat || _.longitude > ne.lng) {
      return false;
    }
    return true;
  });
};
